// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"96c08680","57":"61a31035","77":"6449a4bf","136":"ed1c652c","198":"169ec5b9","213":"8edf1a93","321":"a821b464","473":"522fb7d8","565":"a67914a0","605":"a79b600e","656":"68081d78","771":"5ab3c373","785":"56338d76","959":"27af7752"}[chunkId] + ".chunk.js";
};